import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import OrderProp from '../propTypes/orderProp';
import { OPPORTUNITY_TAB, ORDER_TAB } from './helper/orderDetailHelper';
import TabButtons from './TabButtons';
import InfoTab from './components/InfoTab';
import CurrencyProp from '../../profile/propTypes/currencyProp';
import ShopSidebarOrder from '../shopItems/ShopSidebarOrder';
import TenantProp from '../../../commonComponents/propTypes/tenantProp';
import DocumentsTab from './components/DocumentsTab';
import ActivityNotesTab from './components/ActivityNotesTab';

function OrderWrapper(props) {
  const {
    order,
    isAcademy,
    currencies,
    isOpportunity,
    tenant,
    onCreditNotesClick,
    onAddDocument,
    isLoadingBtn,
    isLoading,
    onSaveOrder,
  } = props;
  const [tabActive, setTabActive] = useState(ORDER_TAB.INFO);

  const handleTabActive = useCallback(
    newTab => setTabActive(newTab),
    [setTabActive],
  );
  return (
    <div className="order-content-wrapper">
      <TabButtons
        active={tabActive}
        onClick={handleTabActive}
        isOpportunity={isOpportunity}
      />
      <div className="order-content-container">
        <div className="main-tab">
          {tabActive === ORDER_TAB.INFO ? (
            <InfoTab
              order={order}
              isAcademy={isAcademy}
              isOpportunity={isOpportunity}
              currencies={currencies}
              onCreditNotesClick={onCreditNotesClick}
            />
          ) : null}
          {isOpportunity && tabActive === OPPORTUNITY_TAB.ACTIVITY_NOTES ? (
            <ActivityNotesTab entity={order} key={order.status} />
          ) : null}
          {isOpportunity && tabActive === OPPORTUNITY_TAB.DOCUMENTS ? (
            <DocumentsTab
              order={order}
              onAddDocument={onAddDocument}
              isLoadingBtn={isLoadingBtn}
            />
          ) : null}
        </div>
        <ShopSidebarOrder
          order={order}
          isAcademy={isAcademy}
          tenant={tenant}
          isOpportunity={isOpportunity}
          isLoading={isLoading}
          onSaveOrder={onSaveOrder}
        />
      </div>
    </div>
  );
}

OrderWrapper.propTypes = {
  order: PropTypes.shape(OrderProp.propType).isRequired,
  isAcademy: PropTypes.bool,
  isOpportunity: PropTypes.bool,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType)),
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
  onCreditNotesClick: PropTypes.func.isRequired,
  onAddDocument: PropTypes.func.isRequired,
  isLoadingBtn: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSaveOrder: PropTypes.func.isRequired,
};

OrderWrapper.defaultProps = {
  isAcademy: false,
  isOpportunity: false,
  currencies: [],
  isLoadingBtn: false,
  isLoading: false,
};

export default OrderWrapper;
